module.exports = __webpack_public_path__ + "img/prg-big-1.a013fbc3.jpg";